// Imports: Dependencies
import {all, fork} from 'redux-saga/effects';
// Imports: Redux Sagas
import {authSaga} from './auth';
import { iLearnSaga } from './ilearn';
// Redux Saga: Root Saga
export function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(iLearnSaga),
  ]);
}
